import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import styles from './styles/Hero.css'
import Header from 'components/typography/Header'
import PartnersPanel from '../partners/PartnersPanel'
import Link from '../misc/Link'
import classNames from 'classnames'
import Button from '../forms/Button'
import { toggleModal } from 'store/ui/actions'
import { setMode } from '../../store/login-modal/actions'
import { selectDistinctSourcesMillions, selectCitationsBillions } from '../../store/home/selectors'

const HeaderAnimation = () => (
  <div className={styles.heroHeaderAnimationContainer}>
    <Header level={2} className={classNames(styles.heroHeader, styles.frame1)}>
      Ask a question, get an answer backed by real research
    </Header>
    <Header level={2} className={classNames(styles.heroHeader, styles.frame2)}>
      Find sources for claims made by language models like ChatGPT
    </Header>
    <Header level={2} className={classNames(styles.heroHeader, styles.frame3)}>
      Find expert analyses and opinions on any topic
    </Header>
    <Header level={2} className={classNames(styles.heroHeader, styles.frame4)}>
      Find if research has been supported or contrasted
    </Header>
    <Header level={2} className={classNames(styles.heroHeader, styles.frame5)}>
      Find appropriate references and data when writing papers
    </Header>
    <Header level={2} className={classNames(styles.heroHeader, styles.frame6)}>
      Find highly supported researchers in Parkinson's disease
    </Header>
    <Header level={2} className={classNames(styles.heroHeader, styles.frame7)}>
      Find Key Opinion Leaders researching Bevacizumab
    </Header>
  </div>
)

const IllustrationAnimation = () => (
  <div className={styles.illoContainer}>
    <img
      alt='hero'
      className={styles.illoBackground}
      src={`${CONFIG.assetsBaseURL}/images/illustrations/home-background-illo-v2.png`}
    />
    <div className={classNames(styles.illoAnimation, styles.frame1)}>
      <img
        alt='assistant_ask_question'
        className={styles.illoAnimationImg}
        src={`${CONFIG.assetsBaseURL}/images/illustrations/assistant-ask-question.png`}
        width='1094'
        height='798'
      />
    </div>
    <div className={classNames(styles.illoAnimation, styles.frame2)}>
      <img
        alt='assistant_validate_claims'
        className={styles.illoAnimationImg}
        src={`${CONFIG.assetsBaseURL}/images/illustrations/assistant-validate-claims.png`}
        width='1094'
        height='798'
      />
    </div>
    <div className={classNames(styles.illoAnimation, styles.frame3)}>
      <img
        alt='expert analysis'
        className={styles.illoAnimationImg}
        src={`${CONFIG.assetsBaseURL}/images/illustrations/expert-analysis-v2.png?v=3`}
        width='1094'
        height='798'
      />
    </div>
    <div className={classNames(styles.illoAnimation, styles.frame4)}>
      <img
        alt='research that is supported or contrasted'
        className={styles.illoAnimationImg}
        src={`${CONFIG.assetsBaseURL}/images/illustrations/find-research-supported-contrasted-v2.png`}
        width='1279'
        height='927'
      />
    </div>
    <div className={classNames(styles.illoAnimation, styles.frame5)}>
      <img
        alt='find appropriate references'
        className={styles.illoAnimationImg}
        src={`${CONFIG.assetsBaseURL}/images/illustrations/what-to-reference-v2.png`}
        width='1286'
        height='866'
      />
    </div>
    <div className={classNames(styles.illoAnimation, styles.frame6)}>
      <img
        alt='highly supported authors'
        className={styles.illoAnimationImg}
        src={`${CONFIG.assetsBaseURL}/images/illustrations/highly-supported-authors-v2.png`}
        width='1106'
        height='1042'
      />
    </div>
    <div className={classNames(styles.illoAnimation, styles.frame7)}>
      <img
        alt='key opinion leaders'
        className={styles.illoAnimationImg}
        src={`${CONFIG.assetsBaseURL}/images/illustrations/key-opinon-leaders-v2.png`}
        width='995'
        height='976'
      />
    </div>
  </div>
)

const Hero = ({ children }) => {
  const dispatch = useDispatch()
  const history = useHistory()

  const user = useSelector(({ ui }) => ui.user)
  const fetchingUser = useSelector(({ ui }) => ui.fetchingUser)

  const citationsBillions = useSelector(({ home }) => selectCitationsBillions(home))
  const distinctSourcesMillions = useSelector(({ home }) => selectDistinctSourcesMillions(home))

  const handleSignup = () => {
    dispatch(setMode('register'))
    dispatch(toggleModal('login'))
  }

  return (
    <div className={styles.heroContainer}>
      {children}
      <div className={styles.heroLayout}>
        <div className={styles.heroHeaderContainer}>
          <HeaderAnimation />
          <div
            className={classNames(styles.userBtns, {
              [styles.showBtns]: !fetchingUser
            })}
          >
            <Button
              bold
              color='blue'
              className={styles.link}
              onClick={user ? () => history.push('/assistant') : handleSignup}
            >
              {user ? 'Start now' : `Start your free ${CONFIG.trialLength}-day trial`}
            </Button>
            <Link
              bold
              blue
              to={CONFIG.bookDemoURL}
            >
              <Button
                className={classNames(styles.secondaryCtaBtn, styles.link)} bold
              >
                Book a demo <i className={`icon icon-right-arrow ${styles.arrowImg}`} />
              </Button>
            </Link>
          </div>
        </div>
        <IllustrationAnimation />
        <div className={styles.content}>
          <div className={styles.countPanel}>
            <Header level={3} className={styles.count}>
              <strong>{`${citationsBillions}b`}</strong> citation statements extracted and analyzed from
              over <strong>{distinctSourcesMillions}m</strong> full-text articles
            </Header>
            <Link className={styles.sampleLink} blue bold to='/reports/association-between-amygdala-hyperactivity-to-gVamGz'>
              See example publication report
            </Link>
          </div>
          <PartnersPanel
            header=''
            subheader='Trusted by leading Universities, Publishers, and Corporations across the world.'
            wideLayout
          />
        </div>
      </div>
    </div>
  )
}

export default Hero
